import React from 'react';
import { ImageDto } from '@src/types/types.ts';
import CaptionedImage from '../atoms/ImageWithCaption';

interface ImagesBarProps {
  images: {
    image: ImageDto;
    alt?: string;
    caption?: string;
  }[];
  className?: string;
}

export const ImagesBar: React.FC<ImagesBarProps> = ({
  images,
  className = '',
}) => {
  return (
    images?.length > 0 && (
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 print:grid-cols-2 gap-20 print:break-inside-avoid ${className}`}
      >
        {images[0] && (
          <CaptionedImage
            image={images[0].image}
            alt={images[0]?.alt}
            caption={images[0]?.caption}
          />
        )}
        {images[1] && (
          <CaptionedImage
            image={images[1].image}
            alt={images[1]?.alt}
            caption={images[1]?.caption}
          />
        )}
      </div>
    )
  );
};

export default ImagesBar;
